export default "__VITE_ASSET__BgySaT$i__"